import { DataBean } from "../DataBean";

export class CashDeskAccountOffice extends DataBean {

    public async getCashDeskAccountCatalog(officeID: any, accountID: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashDeskAccountCatalog_Number_Number", [officeID, accountID]);
    }

}